import * as Highcharts from "highcharts";
import st from './styles.module.scss';
import { CropCondition } from "@baseTypes/service/dashboard/IScoutingDashboardService";
import { formatNumber2d } from "@utils/format/number";
import colors from "@infobis/ui-styles-utils/colors";

export const toggleSeriesOpacity = function (chart: Highcharts.Chart, opacity: number, excludeIndex?: number) {
	chart.series.forEach((s, i) => {
		if (excludeIndex !== i) {
			s.data.forEach(d => {
				d.graphic?.css({ opacity })
			})
		}
	})
}

export const toggleSeriesOnMouseBackgroundInteraction = function (chart: Highcharts.Chart) {
	// @ts-ignore
	chart.pane[0].background.forEach((bg, index) => {
		bg.element.onmouseover = function () {
			toggleSeriesOpacity(chart, 0, index)
			chart.tooltip.refresh(chart.series[index].points[0])
		}

		bg.element.onmouseout = function () {
			toggleSeriesOpacity(chart, 1)

			chart.tooltip.hide()
		}
	})
}

export const addDataLabels = function(chart: Highcharts.Chart, fieldConditions: CropCondition[]) {
	// @ts-ignore
	chart.customDataLabels?.forEach(label => label.destroy())

	const calcYForChartLabels = (i: number) => {
		const arg = i === 0 ? 0.35 : i === 2 ? 1.8 : 1.1

		return (arg + i + 0.35) * 14
	}

	// @ts-ignore
	chart.customDataLabels = fieldConditions.map((condition, i) =>
		chart.renderer.text(`${formatNumber2d(condition.total)} Га`, chart.chartWidth / 4, calcYForChartLabels(i), true)
			.addClass(st['label'])
			.css({ color: colors.TYPO_PRIMARY, fontSize: '12px', lineHeight: '18px', fontWeight: '500', display: 'block', width: 70 })
			.add()
	)
}